import { isAbsence, cleanNotes } from '../../utils/turniAbsences';
import { isOvernightShift, buildOvernightSplit, nextDayString } from './overnightSplit';

// Solo i turni lavorativi si duplicano col drag & drop: le assenze seguono il
// flusso richiesta/approvazione e non vanno copiate da un giorno all'altro.
export const canDuplicateShift = (shift, targetDate) =>
  !!shift && !isAbsence(shift.shift_type) && shift.date !== targetDate;

// Nuovo record con i soli dati "di pianificazione": timbratura ed emergenze
// notturne appartengono al turno originale e non vengono copiate.
export const buildDuplicateShift = (shift, targetDate) => ({
  id: null,
  date: targetDate,
  shift_type: shift.shift_type,
  start_time: shift.start_time ? shift.start_time.substring(0, 5) : '',
  end_time: shift.end_time ? shift.end_time.substring(0, 5) : '',
  operator_name: shift.operator_name,
  notes: cleanNotes(shift.notes),
  is_overtime: !!Number(shift.is_overtime),
  shift_period: shift.shift_period || '',
});

// Una notte inserita come turno singolo è salvata in due righe: la "testa" fino
// alle 23:59 e la coda del giorno dopo dalle 00:00 (overnightSplit.js). Duplicando
// la testa va copiata anche la coda, altrimenti si copia solo metà turno.
export const needsNightTail = (shift) =>
  shift.shift_period === 'notte' && (shift.end_time || '').startsWith('23:59');

export const findNightTail = (head, shifts) => {
  const tailDate = nextDayString(head.date);
  return shifts.find(s =>
    s.operator_name === head.operator_name &&
    s.date === tailDate &&
    s.shift_period === 'coda_della_notte' &&
    (s.start_time || '').startsWith('00:00'));
};

// Cerca la coda tra i turni già caricati; se la notte è l'ultimo giorno del mese
// la coda sta nel mese dopo, che viene caricato con `fetchMonth` solo in quel caso.
export const resolveNightTail = async (head, loadedShifts, fetchMonth) => {
  if (!needsNightTail(head)) return undefined;
  const tail = findNightTail(head, loadedShifts);
  const tailMonth = nextDayString(head.date).slice(0, 7);
  if (tail || tailMonth === head.date.slice(0, 7)) return tail;
  return findNightTail(head, (await fetchMonth(tailMonth)) || []);
};

// Righe da salvare per duplicare `shift` su `targetDate`: una, oppure notte + coda.
export const buildDuplicateShifts = (shift, targetDate, tail) => {
  const copy = buildDuplicateShift(shift, targetDate);
  if (isOvernightShift(copy)) {
    const { firstShift, secondShift } = buildOvernightSplit(copy);
    return [firstShift, secondShift];
  }
  if (!tail) return [copy];
  return [copy, buildDuplicateShift(tail, nextDayString(targetDate))];
};
